import { useEffect, useState, useCallback } from 'react';
import { fetchColaboradores } from '../../services/colaboradorService';
import { Colaborador } from '../../interfaces/colaborador.interface';

const useFetchColaboradores = () => {
    const [colaboradores, setColaboradores] = useState<Colaborador[]>([]);
    const [loadingColaboradores, setLoadingColaboradores] = useState(true);
    const [errorColaboradores, setErrorColaboradores] = useState<string | null>(null);

    const refetchColaboradores = useCallback(async () => {
        setLoadingColaboradores(true);
        try {
            const data = await fetchColaboradores();
            setColaboradores(data);
        } catch (err) {
            setErrorColaboradores('Falha ao buscar colaboradores');
        } finally {
            setLoadingColaboradores(false);
        }
    }, []);

    useEffect(() => {
        refetchColaboradores();
    }, [refetchColaboradores]);

    return { colaboradores, loadingColaboradores, errorColaboradores, refetchColaboradores };
};

export default useFetchColaboradores;
